
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CPLoader extends Vue {

  @Prop({ required: false })
  public loaderText!: string;


}
